import React from 'react';
import { useTranslation } from 'react-i18next';

const NotFound: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section>
      <h1 className="text-2xl md:text-3xl font-bold mb-6 text-[#111D4E]">{t('notFound.title')}</h1>
      <div className="bg-white text-gray-800 rounded-xl p-6">
        {t('notFound.message')}
      </div>
    </section>
  );
};

export default NotFound;
